import {
  DOCUSIGN_INITIATE_SAGA,
  DOCUSIGN_INITIATE_START,
  DOCUSIGN_INITIATE_SUCCESS,
  DOCUSIGN_INITIATE_FAIL,
  DOCUSIGN_GET_ENVELOPE_SAGA,
  DOCUSIGN_GET_ENVELOPE_START,
  DOCUSIGN_GET_ENVELOPE_SUCCESS,
  DOCUSIGN_GET_ENVELOPE_FAIL,
  DOCUSIGN_RESET,
} from '../../actionLabels/docusign';

// ── Initiate DocuSign signing ──────────────────────────────────────────────────
/** Trigger saga to create a DocuSign envelope and obtain the signing URL */
export const docusignInitiateSaga = (payload) => ({ type: DOCUSIGN_INITIATE_SAGA, payload });
export const docusignInitiateStart = () => ({ type: DOCUSIGN_INITIATE_START });
export const docusignInitiateSuccess = (data) => ({ type: DOCUSIGN_INITIATE_SUCCESS, payload: data });
export const docusignInitiateFail = (error) => ({ type: DOCUSIGN_INITIATE_FAIL, payload: error });

// ── Get envelope status ────────────────────────────────────────────────────────
/** Poll/fetch the current status of a specific DocuSign envelope */
export const docusignGetEnvelopeSaga = (payload) => ({ type: DOCUSIGN_GET_ENVELOPE_SAGA, payload });
export const docusignGetEnvelopeStart = () => ({ type: DOCUSIGN_GET_ENVELOPE_START });
export const docusignGetEnvelopeSuccess = (data) => ({ type: DOCUSIGN_GET_ENVELOPE_SUCCESS, payload: data });
export const docusignGetEnvelopeFail = (error) => ({ type: DOCUSIGN_GET_ENVELOPE_FAIL, payload: error });

// ── Reset DocuSign state ───────────────────────────────────────────────────────
/** Clear DocuSign state when the invest modal is closed or re-opened */
export const docusignReset = () => ({ type: DOCUSIGN_RESET });
